import { _ as _applyDecoratedDescriptor } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import { sanitizeHtml } from 'beebee-helper/helpers/safe-string';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div\n  class=\"checkbox checkbox-adv {{@class}} {{if @disabled \'disabled\'}}\"\n  role=\"checkbox\"\n  aria-checked=\"{{if @content \'true\' \'false\'}}\"\n  aria-disabled=\"{{if @disabled \'true\' \'false\'}}\"\n  aria-labelledby=\"{{this.labelId}}\"\n  tabindex=\"{{if @disabled \'-1\' \'0\'}}\"\n  {{on \"click\" this.toggleCheck}}\n  {{on \"keydown\" this.handleKeydown}}\n>\n  <div class=\"check {{if @content \'checked\'}}\">\n    <FaIcon @icon=\"check\" class=\"checked-icon\" />\n  </div>\n\n  <span id={{this.labelId}}>\n    {{this.labelEscape}}\n    {{#if @required}}\n      <span class=\"required\">{{t \'required\'}}</span>\n    {{/if}}\n  </span>\n</div>");

var _class;
let BbCheckboxComponent = (_class = class BbCheckboxComponent extends Component {
  get labelId() {
    return `checkbox-label-${guidFor(this)}`;
  }
  get labelEscape() {
    // Labels may intentionally contain markup (icons, <b>): sanitize, don't escape.
    return this.args.label ? sanitizeHtml(this.args.label) : '';
  }
  toggleCheck() {
    if (this.args.disabled) {
      return;
    }
    const newContent = !this.args.content;
    this.args.setContent?.(newContent);
    if (this.args.action) {
      this.args.action(newContent);
    }
  }
  handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleCheck();
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "toggleCheck", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCheck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeydown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeydown"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbCheckboxComponent);

export { BbCheckboxComponent as default };
//# sourceMappingURL=bb-checkbox.js.map
